<template>
  <viewe style="display: flex; flex-direction: row;">
    <div class="card">
      <div style="font-size: 24px">{{ countOfEmployees }}</div>
      <div>公司人数</div>
    </div>
    <div class="card">
      <div style="font-size: 24px">{{ countOfIssues[0] }}</div>
      <div>待解决</div>
    </div>
    <div class="card">
      <div style="font-size: 24px">{{ countOfIssues[1] }}</div>
      <div>待验收</div>
    </div>
    <div class="card">
      <div style="font-size: 24px">{{ countOfIssues[2] }}</div>
      <div>已验收</div>
    </div>
  </viewe>
</template>

<script>
import app from "@/App";

export default {
  name: "Home",
  data() {
    return {
      countOfEmployees: '-',
      countOfIssues: {},
    }
  },
  created() {
    app.methods.getUser().then(res => {
      this.user = res.data.data
      this.getEmployees().then(res => {
        this.countOfEmployees = res.data.data.total;
      });
      app.methods.getCountOfAllIssues().then(res => {
        for (const statistics of res.data.data) {
          this.countOfIssues[statistics.status] = statistics.count
        }
        console.log(this.countOfIssues)
      });
    })
  },
  methods: {
    openLoginPage() {
      this.$router.replace({path: '/login'})
    },
    getEmployees() {
      return app.methods.getEmployees(this.user.companyId);
    },
  }
}
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
}
</style>
